import {
  Divider,
  Grid2,
  IconButton,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  IconAlignBoxBottomCenter,
  IconCirclePlus,
  IconMinus,
  IconPlus,
  IconSchool,
  IconTrendingDown,
  IconTrendingUp,
  IconUsersGroup,
  IconChalkboard,
  IconCalendarDollar,
  IconInfoSquareRounded,
} from "@tabler/icons-react";

const IndicatorsCard = ({
  data,
}: {
  data: Array<{
    id: number | string;
    size?: {};
    icon?: string;
    title?: string;
    value?: string | number;
    percentage?: string | number;
    variation?: string | number;
    titleButton?: string;
    onButton?: () => void;
    subtitle?: string;
    hasInfo?: string;
  }>;
}) => (
  <Grid2 container spacing={2}>
    {data?.map((item, index) => (
      <Grid2
        key={`${item?.id}-${index}`}
        size={item?.size}
        sx={styles.cardStyle}
      >
        <Stack sx={styles.stackStyle}>
          {item?.icon === "icon_school" && (
            <IconSchool size={18} style={styles.iconStyle} />
          )}
          {item?.icon === "icon_calendar_dollar" && (
            <IconCalendarDollar size={14} style={styles.iconStyle} />
          )}
          {item?.icon === "icon_users" && (
            <IconUsersGroup size={18} style={styles.iconStyle} />
          )}
          {item?.icon === "icon_box" && (
            <IconAlignBoxBottomCenter size={18} style={styles.iconStyle} />
          )}
          {item?.icon === "icon_chalkboard" && (
            <IconChalkboard size={18} style={styles.iconStyle} />
          )}
          <Typography fontSize={14}>{item?.title}</Typography>

          {item?.hasInfo && (
            <Tooltip title={item?.hasInfo}>
              <IconButton
                size="small"
                sx={{
                  padding: 0,
                  cursor: "pointer",
                  color: "#9c27b0",
                  width: "14px",
                }}
              >
                <IconInfoSquareRounded />
              </IconButton>
            </Tooltip>
          )}
        </Stack>
        <Stack sx={styles.stackStyleTwo}>
          <Typography fontWeight={700} fontSize={22}>
            {item?.value}
          </Typography>
          {item.percentage &&
            (Number(item?.percentage) >= 0 ? (
              <>
                <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
                  <IconTrendingUp size={18} color="green" />
                  <Typography variant="h3" color="green">
                    {item?.percentage}%
                  </Typography>
                </Stack>
                <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
                  <IconPlus size={18} color="green" />
                  <Typography variant="h3" color="green">
                    {item?.variation}
                  </Typography>
                </Stack>
              </>
            ) : (
              <>
                <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
                  <IconTrendingDown size={18} color="red" />
                  <Typography variant="h3" color="red">
                    {item?.percentage}
                  </Typography>
                </Stack>
                <Stack sx={{ flexDirection: "row", alignItems: "center" }}>
                  <IconMinus size={18} color="red" />
                  <Typography variant="h3" color="red">
                    {item?.variation}
                  </Typography>
                </Stack>
              </>
            ))}
        </Stack>
        {item?.titleButton && item?.onButton && (
          <>
            <Divider sx={styles.dividerStyle} />
            <Stack sx={styles.stackStyleButton} onClick={item?.onButton}>
              <IconCirclePlus size={18} />
              <Typography fontSize={12}>{item?.titleButton}</Typography>
            </Stack>
          </>
        )}
        {item?.subtitle && (
          <>
            <Divider sx={styles.dividerStyle} />
            <Stack sx={styles.stackStyleThree}>
              <Typography fontSize={12}>{item?.subtitle}</Typography>
            </Stack>
          </>
        )}
      </Grid2>
    ))}
  </Grid2>
);

const styles = {
  cardStyle: {
    backgroundColor: "secondary.main",
    borderRadius: 2,
    padding: 2,
  },
  stackStyle: {
    flexDirection: "row",
    alignItems: "center",
    gap: 1,
    padding: 1,
    borderRadius: 2,
    backgroundColor: "secondary.dark",
  },
  stackStyleTwo: {
    flexDirection: "row",
    gap: 1,
    padding: 1,
    borderRadius: 2,
  },
  stackStyleThree: {
    flexDirection: "row",
    alignItems: "center",
    padding: 1,
    gap: 1,
  },
  stackStyleButton: {
    flexDirection: "row",
    alignItems: "center",
    padding: 1,
    gap: 1,
    borderRadius: 5,
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "secondary.dark",
    },
  },
  iconStyle: {
    color: "#7600ED",
  },
  dividerStyle: {
    backgroundColor: "primary.contrastText",
    marginTop: 1,
    marginBottom: 1,
  },
};

export default IndicatorsCard;
